export default "__VITE_ASSET__CU7MI8zS__"